/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x591f04 from'./../../message.js';class IsEditorBundleUploadedResponse extends _0x591f04{constructor(_0x3c3c2c){super(),this['isUploaded']=_0x3c3c2c;}['toJSON'](){return{'isUploaded':this['isUploaded']};}static['fromJSON'](_0x111b9d){return new IsEditorBundleUploadedResponse(_0x111b9d['isUploaded']);}}IsEditorBundleUploadedResponse['DESCRIPTOR_NAME']='IsEditorBundleUploadedResponse',IsEditorBundleUploadedResponse['DESCRIPTOR']={'fields':{'isUploaded':{'type':'bool','id':0x1}}};export default IsEditorBundleUploadedResponse;